// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--DE2mS","title":"a10a3f92e9--title--cYeKp","list":"a10a3f92e9--list--CfYsv","item":"a10a3f92e9--item--U9wHr"};